// src/services/corrigirFlagPorId.js
import { db } from "../firebase";
import {
  collection,
  getDocs,
  doc,
  getDoc,
  setDoc
} from "firebase/firestore";

/**
 * Marca acertou: true para um idInterno específico em uma categoria,
 * sem alterar pontos, pontosmodo ou porcentagem.
 *
 * @param {Object} params
 * @param {string} params.modo        ex: "criticschoice"
 * @param {string} params.tipo        ex: "indicados" ou "vencedores"
 * @param {string} params.categoriaId ex: "melhorator"
 * @param {string} params.idCorreto   idInterno que deve virar acertou: true
 */
export async function corrigirFlagPorId({ modo, tipo, categoriaId, idCorreto }) {
  if (!modo || !tipo || !categoriaId || !idCorreto) {
    console.warn("Parâmetros insuficientes em corrigirFlagPorId", {
      modo,
      tipo,
      categoriaId,
      idCorreto
    });
    return;
  }

  const modoFinal = modo.includes("-") ? modo : `${modo}-${tipo}`;
  const idAlvo = String(idCorreto).trim();

  console.log("🔧 corrigirFlagPorId", {
    modoFinal,
    categoriaId,
    idAlvo
  });

  const usuariosRef = collection(db, "usuarios");
  const usuariosSnap = await getDocs(usuariosRef);

  for (const usuarioDoc of usuariosSnap.docs) {
    const uid = usuarioDoc.id;
    const docModoRef = doc(db, `usuarios/${uid}/snapDropdown2026/dados`);
    const docModoSnap = await getDoc(docModoRef);

    if (!docModoSnap.exists()) {
      continue;
    }

    const dadosTudo = docModoSnap.data();
    const dadosModo = dadosTudo[modoFinal];

    if (!dadosModo || typeof dadosModo !== "object") {
      continue;
    }

    const categoria = dadosModo[categoriaId];
    if (!categoria || typeof categoria !== "object") {
      continue;
    }

    let mudou = false;
    const novasPosicoes = { ...categoria };

    for (const [pos, dados] of Object.entries(categoria)) {
      if (pos === "dataAtualizacao" || pos === "pontos") continue;
      if (!dados || typeof dados !== "object") continue;

      const idInterno = String(dados.idInterno || "").trim();
      if (!idInterno) continue;

      if (idInterno === idAlvo && dados.acertou !== true) {
        novasPosicoes[pos] = {
          ...dados,
          acertou: true
        };
        mudou = true;
      }
    }

    if (mudou) {
      dadosModo[categoriaId] = novasPosicoes;
      dadosTudo[modoFinal] = dadosModo;
      await setDoc(docModoRef, dadosTudo, { merge: true });
      console.log(`💾 acertou:true aplicado para usuário ${uid} em ${modoFinal}/${categoriaId}`);
    }
  }

  console.log("✅ corrigirFlagPorId finalizado para", modoFinal, categoriaId, idAlvo);
}